import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import useDownloadFile from "@/utils/hooks/useDownloadFile";
import store from "@/store";

import { reportCustomModel } from "@/constants/report/report-custom";

export default function useExportCsv() {
  const { openErrorModal } = useValidationModal();

  const { onDownloadFile } = useDownloadFile();

  const getBrandRef = () => {
    return new URLSearchParams(window.location.search).get("brandRef");
  };

  const exportCsv = (searchVal) => {
    const brandSelect = reportCustomModel.find((o) => {
      return o.brand == getBrandRef();
    });

    const model = {
      api: brandSelect.api,
      method: "GET",
      payload: {
        search: searchVal,
        start: null,
        limit: null,
        startDate: "",
        finishDate: "",
        generateReport: true,
        "Ordering[0].Seq": null,
        "Ordering[0].Key": null,
        "Ordering[0].Value": null,
      },
      responseType: "blob",
    };

    store
      .dispatch("api/apiRequest", model)
      .then((response) => {
        onDownloadFile(response, "CustomerList", ".xlsx");
      })
      .catch((error) => {
        openErrorModal(
          error.data.error.locale["th-th"].title,
          error.data.error.locale["th-th"].message
        );
      })
      .finally(() => {});
  };

  return {
    exportCsv,
  };
}
